import { useEffect, useMemo } from "react";
import QuoteReviewWarningsTable from "./quoteReviewWarningsTable";

const QuoteReviewWarningsForItems = ({
    warnings,
    quoteItems,
    onAddWarning,
    onRemoveWarning,
    onAcknowledgedWarningChange,
    onApprovedWarningChange
}) => {

    const uniqueItemErrors = useMemo(() => {
        const allErrors = quoteItems.flatMap(item => item.validationErrors);

        // Deduplicate by the 'error' property only
        const errorMap = new Map();

        for (const err of allErrors) {
            if (!errorMap.has(err.error)) {
            errorMap.set(err.error, err);
            }
        }

        return Array.from(errorMap.values());
    }, [quoteItems]);


    const itemWarningsInDB = useMemo(() => {
        return warnings?.filter(x => x.sectionId === "item") ?? [];    
    }, [warnings]);

    const itemWarningsTableData = useMemo(() => {
        const tableData = [];
        const acknowledgedWarnings = itemWarningsInDB.filter(x => x.acknowledged);
        const approvedWarnings = itemWarningsInDB.filter(x => x.approved);
        const acknowledgedMap = new Map(acknowledgedWarnings.map(w => [w.id, w]));
        const approvedMap = new Map(approvedWarnings.map(w => [w.id, w]));

        uniqueItemErrors.forEach(error => {
            const itemsWithThisError = quoteItems.filter(item =>
                item.validationErrors.some(e => e.error === error.error)
            );

            tableData.push({           
                id: error.error,
                warning: error.error,
                items: itemsWithThisError.map(item => {
                    const warningId = `${item.guid}_${error.id}`;
                    const acknowledged = acknowledgedMap.get(warningId);
                    const approved = approvedMap.get(warningId);

                    const itemErrorWarningDetail = item.validationErrors.find(e => e.error === error.error)?.detail;

                    return ({
                        ...item,
                        id: warningId,
                        acknowledged: !!acknowledged,
                        acknowledgedBy: acknowledged?.acknowledgedBy || "",
                        approved: !!approved,
                        approvedBy: approved?.approvedBy || "",
                        detail: <div style={{ flexDirection: "column" }}><div><strong>{item.quoteGroupDescription}: </strong><span>{item.internalName}</span></div><div dangerouslySetInnerHTML={{ __html: itemErrorWarningDetail }}></div></div>
                    });
                })
            });
        });

        return tableData;
    }, [itemWarningsInDB, uniqueItemErrors, quoteItems]);


    useEffect(() => {

        // Now we have a list of what warnings there currently are, we need to add any that aren't known to the quoteRevision, so 
        // we can store when they are acknowledged/approved
        itemWarningsTableData.forEach(warning => {
            warning.items.forEach(item => {
                if (!itemWarningsInDB.some(w => w.id === item.id)) {
                    onAddWarning({
                        id: item.id,
                        sectionId: "item",
                        acknowledged: false,
                        acknowledgedBy: null,
                        approved: false,
                        approvedBy: null
                    });
                }
            })
        })

        /*
        * Remove any warnings that are no longer needed from the quoteRevision
        */

        const warningsInTable = itemWarningsTableData.flatMap(warning => warning.items);

        const noLongerNeededWarnings = itemWarningsInDB.filter(warning => 
            !warningsInTable.find(i => i.id === warning.id)
        );

        noLongerNeededWarnings.forEach(warningToRemove => {
            console.log("Removing no longer needed warning", warningToRemove);
            onRemoveWarning(warningToRemove);
        });
    }, [itemWarningsTableData, itemWarningsInDB, onAddWarning, onRemoveWarning]); 

    return (
        <QuoteReviewWarningsTable
            header="Item Warnings"
            warnings={itemWarningsTableData}
            onAcknowledgedWarningChange={onAcknowledgedWarningChange}
            onApprovedWarningChange={onApprovedWarningChange}
        />    
    );
}
export default QuoteReviewWarningsForItems;